const localLanguage=[
    {
        id:1,
        code:'th',
        currency:'thb',
        nameTh:"ไทย",
        nameEn:"Thai"
    },
    {
        id:2,
        code:'en',
        currency:'gbp',
        nameTh:"อังกฤษ",
        nameEn:"English"
    }
]

export default localLanguage